import { SVGProps } from 'react';

const AmericanExpressIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="124"
      height="24"
      viewBox="0 0 124 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_64_1499)">
        <path
          d="M74 24V20.1971H71.1046L69.6139 18.5488L68.1157 20.1971H58.5693V12.5149H55.4881L59.31 3.86561H62.9958L64.3116 6.82871V3.86565H68.8739L69.6661 6.09853L70.4634 3.86565H74V0H50V24H74ZM71.5923 19.2353H74L70.8151 15.8578L74 12.5188H71.6306L69.6637 14.6681L67.7157 12.5188H65.3075L68.4738 15.8771L65.3075 19.2354H67.6488L69.6253 17.0668L71.5923 19.2353ZM72.1556 15.8607L74 17.8229V13.9148L72.1556 15.8607ZM61.4215 17.6809V16.635H65.2114V15.1189H61.4215V14.0732H65.3074V12.5187H59.5888V19.2353H65.3074V17.6809H61.4215V17.6809ZM72.1865 11.544H74V4.82751H71.179L69.6725 9.01086L68.1757 4.82751H65.3068V11.544H67.1202V6.84249L68.8474 11.544H70.4593L72.1865 6.83279V11.544ZM63.2439 11.544H65.3069L62.3421 4.82751H59.9817L57.0167 11.544H59.0317L59.5883 10.2008H62.6778L63.2439 11.544ZM62.0447 8.69429H60.2214L61.1331 6.49704L62.0447 8.69429Z"
          fill="#006FCF"
        />
      </g>
      <defs>
        <clipPath id="clip0_64_1499">
          <rect width="24" height="24" fill="white" transform="translate(50)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AmericanExpressIcon;
